class ComboQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
  
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    quantityUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.validateQtyRules();
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }
  
    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }
    }
  
    onInputChange(event) {
      this.validateQtyRules();
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const cardWrapper = this.closest(".card-wrapper");
      const previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if(previousValue == 1 && event.target.name === "minus"){
        event.preventDefault();
        if(cardWrapper){
          cardWrapper.removeAttribute('selected');
        }
      }
      if (previousValue !== this.input.value){
        this.input.dispatchEvent(this.changeEvent);
        cardWrapper.setAttribute('data-product-quantity', this.input.value)
        if(this.closest("#modal-lines")){
            const sectionId = document.getElementById('multi-select').getAttribute('data-section-id');
            const ogCarouselHandle = cardWrapper.getAttribute('data-carousel');
            const varId = cardWrapper.getAttribute('data-product-id');
            const ogCarousel = document.getElementById(sectionId + '-' + ogCarouselHandle);
            if (ogCarousel) {
                const ogCards = ogCarousel.querySelectorAll(
                '.card-wrapper[data-product-id="' + varId + '"]'
                );
                for (var c = 0; c < ogCards.length; c++) {
                    ogCards[c].querySelector('.quantity__input').value = this.input.value;
                    ogCards[c].setAttribute('data-product-quantity', this.input.value);
                }
                selectionChange();
            }
        }
      } 
    }
  
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        if(buttonPlus){
          buttonPlus.classList.toggle('disabled', value >= max);
        }
      }
    }
  }
  
  customElements.define('combo-quantity-input', ComboQuantityInput);

  function openBundleModal(id) {
    var bundleModal = document.getElementById(id);
    if (bundleModal) {
      document.body.classList.add('overflow-hidden');
      bundleModal.setAttribute('open', '');
      setTimeout(function () {
        window.addEventListener('click', outsideBundleClick);
      }, 800);
    }
  }
  function closeBundleModal(id) {
    var bundleModal = document.getElementById(id);
    if (bundleModal) {
      bundleModal.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      window.removeEventListener('click', outsideBundleClick);
    }
  }
  function outsideBundleClick(event) {
    if (
      !event.target.closest('basket-view-modal__container') &&
      !event.target.closest('.view-button') &&
      !event.target.closest('.card-close') &&
      !event.target.closest('#modal-lines') &&
      !event.target.closest('combo-quantity-input')
      
    ) {
      var bundleModals = document.querySelectorAll('.basket-view-modal');
      for (var b = 0; b < bundleModals.length; b++) {
        if (bundleModals[b].hasAttribute('open')) {
          bundleModals[b].removeAttribute('open');
        }
      }
      document.body.classList.remove('overflow-hidden');
      window.removeEventListener('click', outsideBundleClick);
    }
  }
  function addBundleToCart(event) {
    var itemsArray = [];
    var atcButton = event.target.closest('.view-button');
    var selectedCards = document.getElementById('multi-select').querySelectorAll(".card-wrapper[selected='true']");
    if (selectedCards.length > 0) {
      for (var s = 0; s < selectedCards.length; s++) {
        var id = selectedCards[s].getAttribute('data-product-id');
        var quantity = selectedCards[s].querySelector('.quantity__input').value;
        itemsArray.push({
          id: parseInt(id),
          quantity: parseInt(quantity),
          properties: {
            _uni_bundle_deal: true,
          },
        });
      }
    }

    if (itemsArray.length > 0) {
      atcButton.innerText = 'Adding to Cart...';
      var cartNotification = document.querySelector('cart-notification');
      let formData = {
        items: itemsArray,
        sections: cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          atcButton.innerText = 'Added to Cart';
          checkCart();
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'new-home-deal' });

          setTimeout(() => {
            atcButton.innerText = 'Add Deal to Cart';
          }, 2000);
          setTimeout(() => {
            selectedCards = document.querySelectorAll(".card-wrapper[selected='true']");
            for (var s = 0; s < selectedCards.length; s++) {
              selectedCards[s].removeAttribute('selected');
              selectedCards[s].querySelector('.quantity__input').value = 1;
              selectedCards[s].setAttribute('data-product-quantity', '1');
            }
            const modalLines = document.getElementById('modal-lines');
            const atcFooter = document.getElementById('atc-footer');
            modalLines.innerHTML = '';
            atcFooter.classList.add('hidden');
            var bundleModals = document.querySelectorAll('.basket-view-modal');
            for (var b = 0; b < bundleModals.length; b++) {
              if (bundleModals[b].hasAttribute('open')) {
                bundleModals[b].removeAttribute('open');
              }
            }
            document.body.classList.remove('overflow-hidden');
            window.removeEventListener('click', outsideBundleClick);
          }, 2050);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
  function itemRemove(event){
    const sectionId = document.getElementById('multi-select').getAttribute('data-section-id');
    const selectionCard = event.target.closest('.card-wrapper');
    const ogCarouselHandle = selectionCard.getAttribute('data-carousel');
    const varId = selectionCard.getAttribute('data-product-id');
    const ogCarousel = document.getElementById(sectionId + '-' + ogCarouselHandle);
    if (ogCarousel) {
      const ogCards = ogCarousel.querySelectorAll(
        '.card-wrapper[data-product-id="' + varId + '"]'
      );
      for (var c = 0; c < ogCards.length; c++) {
        ogCards[c].removeAttribute('selected');
        ogCards[c].querySelector('.quantity__input').value = 1;
        ogCards[c].setAttribute('data-product-quantity', '1');
      }
      selectionChange();
    }
  }

  function selectionChange() {
    var allSelectedCards = document.getElementById('multi-select').querySelectorAll(".card-wrapper[selected='true']");
    var atcFooter = document.getElementById('atc-footer');
    var currentPriceDiv = document.getElementById('multi-select-price');
    var oldPriceDiv = document.getElementById('multi-select-price-old');
    var modalPriceDiv = document.getElementById('modal-price');
    var modalOldPriceDiv = document.getElementById('modal-price-old');
    var currencySymbol = document.getElementById('multi-select').getAttribute('data-currency');
    const modalLines = document.getElementById('modal-lines');
    modalLines.innerHTML = '';
    if (allSelectedCards.length > 0) {
      var price = 0;
      var totalQuantity = 0;
      var discountedPrice = 0;
      for (var s = 0; s < allSelectedCards.length; s++) {
        totalCard =
          parseInt(allSelectedCards[s].getAttribute('data-product-price')) *
          parseInt(allSelectedCards[s].getAttribute('data-product-quantity'));
        price = price + totalCard;
        totalQuantity = totalQuantity + parseInt(allSelectedCards[s].getAttribute('data-product-quantity'));
        var modalID =
          allSelectedCards[s].getAttribute('data-carousel') +
          '-' +
          allSelectedCards[s].getAttribute('data-parent-id') + "-modal";  
        const modalCard = allSelectedCards[s].cloneNode(true);
        modalCard.id = modalID;
        modalCard.querySelector('.quantity__input').id = modalID + "-quant";
        if(!document.getElementById('modalID')){
            modalLines.appendChild(modalCard);
            modalCard.classList.add('grid__item');
            modalCard.querySelector('.card-close').addEventListener('click', itemRemove);
        }
      }
      var discount = highestDiscount(totalQuantity);

      if (discount != 0) {
        discountedPrice = price * (1 - discount);
      }
      if (discountedPrice != 0) {
        oldPriceDiv.innerText = currencySymbol + (price / 100).toFixed(2);
        oldPriceDiv.classList.remove('hidden');
        modalOldPriceDiv.innerText = currencySymbol + (price / 100).toFixed(2);
        modalOldPriceDiv.classList.remove('hidden');
        currentPriceDiv.innerText = currencySymbol + (discountedPrice / 100).toFixed(2);
        modalPriceDiv.innerText = currencySymbol + (discountedPrice / 100).toFixed(2);
      } else {
        modalOldPriceDiv.classList.add('hidden');
        currentPriceDiv.innerText = currencySymbol + (price / 100).toFixed(2);
        modalPriceDiv.innerText = currencySymbol + (price / 100).toFixed(2);
      }
      atcFooter.classList.remove('hidden');
    } else {
      atcFooter.classList.add('hidden');
    }
  }